var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.myLamps),function(lamp,d){return (_vm.state !== 'fixed')?_c('div',{key:d,staticClass:"ma-1",class:lamp,style:(_vm.getStyle())}):_vm._e()}),_vm._v(" "),((_vm.state === 'fixed' && (this.color)))?_c('div',{staticClass:"lampTranparent ma-1",style:(_vm.getStyle())}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ec89e78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/TrafficLight.vue
// module id = null
// module chunks = 